import { api } from "./apiClient";

export const permissionsAPI = {
    listProjectRolePermissions: () => api.get("/permissions/project-roles"),
    upsertProjectRolePermissions: (roleName, payload) =>
        api.put(`/permissions/project-roles/${roleName}`, payload),
    resetProjectRolePermissions: (roleName) =>
        api.delete(`/permissions/project-roles/${roleName}`),
};
